import { useEffect, useState } from 'react'
import { WebGLRenderer } from 'three'
import { EffectComposer } from 'postprocessing'

import { IPostEffects } from '../posteffects/posteffects'
import { useAppStore } from '../../shared/store/store'
import { SceneLight } from '../types/scene-light'
import Stats from '@trillionhq/stats.js'

export function usePerformance(
  renderer?: WebGLRenderer,
  composer?: EffectComposer,
  posteffects?: IPostEffects,
  lights?: SceneLight[],
  rootElement?: HTMLElement,
): Stats | undefined {
  const isShowPerformance = useAppStore((state) => state.isShowPerformance)
  const [stats, setStats] = useState<Stats | undefined>()

  useEffect(() => {
    if (!stats || !rootElement) {
      return
    }

    if (isShowPerformance) {
      stats.showPanel(0)

      for (const child of stats.dom.children) {
        const item = child as HTMLElement
        if (item) {
          item.style.position = 'absolute'
          item.style.top = '0'
          item.style.left = '0'
          item.style.width = '15vh'
          item.style.height = 'auto'
        }
      }

      rootElement.appendChild(stats.dom)
    } else {
      stats.showPanel(-1)
      if (rootElement.contains(stats.dom)) {
        rootElement.removeChild(stats.dom)
      }
    }
  }, [isShowPerformance, stats])

  useEffect(() => {
    if (renderer && composer && posteffects && lights && !stats) {
      setStats(Stats())
    }
  }, [renderer, composer, posteffects])

  useEffect(() => {
    return () => {
      if (stats && rootElement) {
        if (rootElement.contains(stats.dom)) {
          rootElement.removeChild(stats.dom)
        }
      }
    }
  }, [])

  return stats
}
